(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/statistics/matchstatistics/assets/javascripts/views/statmatchstatistics.js') >= 0) return;  svs.modules.push('/components/statistics/matchstatistics/assets/javascripts/views/statmatchstatistics.js'); 
(function(Backbone, _, svs) {
  'use strict';

  svs.statistics = svs.statistics || {};
  svs.statistics.views = svs.statistics.views || {};
  svs.statistics.moq = svs.statistics.moq || {};
  svs.statistics.data = svs.statistics.data || {};

  svs.statistics.views.StatMatchStatistics = svs.statistics.views.SportserviceTabBase.extend(
    {
      tagName: 'div',
      firstTime: true,
      classId: 'StatMatchStatistics',
      statisticsMini: {},
      viewId: 'statistik',
      LIVE_STATISTICS: 0,
      playerStatisticsFilter: 0,
      filters: {
        menu: {
          homeTeam: { selected: true },
          awayTeam: { selected: false }
        },
        playerStatisticsFilter: {
          filterValues: {
            4: { name: 'OT', selected: false },
            3: { name: '3:e period', selected: false },
            2: { name: '2:a period', selected: false },
            1: { name: '1:a period', selected: false },
            0: { name: 'Totalt', selected: true }
          },
          selectedKey: 'all'
        }
      },
      events: {
        'click .list-group-item': 'clicked',
        'click .menu-items': 'selectMenu'
      },
      numOfMatches: 5,
      initialize: function(options) {
        if (options) {
          this.options = options;
          svs.statistics.views.SportserviceTabBase.prototype.initialize.apply(
            this,
            [options]
          );
        }

        if (!this.options.params.matchId) {
          return;
        }

        if (
          this.options.params.matchinfo &&
          this.options.params.matchinfo instanceof
            svs.statistics.models.MatchInfo
        ) {
          this.matchInfoModel = this.options.params.matchinfo;
        } else if (!this.matchInfoModel) {
          this.matchInfoModel = new svs.statistics.models.MatchInfo({
            matchId: this.options.params.matchId
          });
          this.matchInfoModel.on('change', this.matchInfoModelLoaded, this);
          if (
            !!(((svs.statistics || {}).data || {}).matchModels || {}).info &&
            !this.options.params.forceFetch
          ) {
            this.matchInfoModel.trigger('change', this.matchInfoModel);
          } else {
            this.matchInfoModel.fetch();
          }
          return;
        }

        this.views = [];
        this.model = new svs.statistics.models.statMatchStatistics({
          urlParams: {
            id: this.options.params.matchId,
            numberOfMatches: this.numOfMatches,
            match: this.matchInfoModel
          },
          observer: this
        });

        this.observer = this.options.params.parent
          ? this.options.params.parent
          : this.model.attributes.observer;
        this.model.on('change', this.render, this);
        this.model.on('fetchError', this.handleFetchError, this);
        this.observer.on('initHandler', this.initHandler, this);
        this.observer.on('closeHandler', this.closeHandler, this);
        this.setupView(this.options);

        this.events = _.extend({}, this.genericEvents, this.events);
        this.delegateEvents();
      },
      matchInfoModelLoaded: function() {
        this.matchInfoModel.off('change');
        this.initialize();
        this.render();
      },
      setupView: function(options) {
        this.statFormLatestMatches = new svs.statistics.views.StatFormLatestMatches(
          { modelReference: this.model, options: options }
        );
        this.views.push(this.statFormLatestMatches);

        this.statLiveStatistics = new svs.statistics.views.StatLiveStatistics({
          modelReference: this.model,
          options: options
        });
        this.views.push(this.statLiveStatistics);
        if (_.isObject(svs.statistics.moq.StatMatchStatisticsMock)) {
          this.statMatchStatisticsMock = new svs.statistics.moq.StatMatchStatisticsMock(
            { modelReference: this.model, options: options, ref: this }
          );
        }
      },
      initHandler: function(e) {
        if (e.currentView.id !== this.viewId) {
          return;
        }
        if (this.statMatchStatisticsMock) {
          this.statMatchStatisticsMock.startPush();
        } else {
          var getInitialData = true;
          if (this.model) this.model.startPush(getInitialData);
        }
      },
      disposeSubviews: function() {
        _.invoke(this.views, 'dispose');
        this.views = [];
      },
      closeHandler: function() {
        if (this.statMatchStatisticsMock) {
          this.statMatchStatisticsMock.stopPush();
        } else {
          if (this.model) this.model.stopPush();
        }
      },
      handleFetchError: function() {
        var _self = this;
        _self.$el.html(svs.statistics.statistics.templates.tryagain({}));
        _self.$('.js-statistics-reload').bind('click', function() {
          $(this).unbind('click');
          _self.model.fetch({
            error: function() {
              _self.handleFetchError();
            }
          });
        });
      },

      updateSubview: function() {
        this.statFormLatestMatches.update(this.model);
      },

      renderWithData: function() {
        if (!this.model) {
          this.$el.html(svs.statistics.statistics.templates.nodata({}));
          return this;
        }
        if (
          !_.isObject(this.model.get('statistics')) ||
          !this.statFormLatestMatches
        ) {
          this.$el.html(svs.statistics.statistics.templates.nodata({}));
          return this;
        }
        var statistics = this.model.get('statistics');
        if (!_.isObject(statistics.sport)) {
          this.$el.html(svs.statistics.statistics.templates.nodata({}));
          return this;
        }
        var id = statistics.sport.id;
        var leagueID = this.matchInfoModel.get('match').league.id;
        var _self = this,
          componentFile = 'stat-match-statistics',
          theme;
        theme = new svs.sport.themeLoader({
          sport: id,
          league: leagueID
        });
        theme.load(function(template, init) {
          if (!template) {
            return _self.$el.html(
              svs.statistics.statistics.templates.nodata({})
            );
          }
          _self.template = template;

          _self.$el.html(_self.template(_self.applyFilters()));
          _self.statFormLatestMatches
            .setElement(_self.$('#latestMatchesContent'))
            .delegateEvents()
            .render();
          _self.statLiveStatistics
            .setElement(_self.$('#statLiveStatistics'))
            .delegateEvents()
            .render();

          if (
            Object.prototype.hasOwnProperty.call(_self.options.params, 'parent')
          ) {
            _self.options.params.parent.trigger('resize');
          }
          if (init) {
            init(componentFile);
          }
        }, componentFile);

        return this;
      },
      clicked: function(event) {
        var matchId = $(event.currentTarget).data('match-id');
        var activeStatisticsMini = $(event.currentTarget).find('.stats-mini');
        var statisticsMiniView = {};
        if (
          $(event.target).hasClass('show-statistics') &&
          _.isNumber(matchId)
        ) {
          if (!this.statisticsMini[matchId]) {
            this.statisticsMini[
              matchId
            ] = new svs.components.models.StatisticsMini({
              observer: this,
              matchId: matchId,
              isLive: false
            });
            statisticsMiniView = new svs.components.views.StatisticsMini({
              modelReference: this.statisticsMini[matchId],
              parent: this.observer
            });
            activeStatisticsMini.html(statisticsMiniView.el);
          }
        }
      },
      selectMenu: function(event) {
        var selectedVal = $(event.currentTarget).attr('value');
        if (
          (selectedVal && selectedVal === 'homeTeam') ||
          (selectedVal && selectedVal === 'awayTeam')
        ) {
          this.filters.menu.homeTeam.selected = this.filters.menu.awayTeam.selected = false;
          this.filters.menu[selectedVal].selected = true;
          this.render({});
        }
      },
      applyFilters: function() {
        var statistics = this.model.get('statistics'); 
        var liveStatistics = statistics;

        if (!liveStatistics) {
          liveStatistics = {};
        }
        var self = this;
        _.each(this.filters.playerStatisticsFilter.filterValues, function(
          filterValue
        ) {
          filterValue.selected = false;
          self.filters.playerStatisticsFilter.filterValues[
            self.playerStatisticsFilter
          ].selected = true;
        });

        var playerStatistics = [];
        if (_.isObject(statistics.playerStatistics)) {
          if (this.filters.menu.homeTeam.selected) {
            playerStatistics = statistics.playerStatistics.homeTeam;
          } else if (this.filters.menu.awayTeam.selected) {
            playerStatistics = statistics.playerStatistics.awayTeam;
          }
        }

        return {
          statistics: statistics,
          liveStatistics: statistics,
          playerStatistics: playerStatistics,
          filters: this.filters
        };
      },

      getModifiedMutuals: function(mutuals) {
        if (!_.isArray(mutuals)) {
          return mutuals;
        }

        var result = [],
          lastHistory = mutuals[mutuals.length - 1].history; 

        if (lastHistory) {
          result = [
            lastHistory.homeWins,
            lastHistory.draws,
            lastHistory.awayWins
          ];
        } else {
          result = mutuals;
        }
        return result;
      },

      onDestroy: function() {
        this.closeHandler();
        this.undelegateEvents();
        this.stopListening();
        this.off();
        if (this.observer) {
          this.observer.off();
          this.observer.stopListening();
          this.observer = null;
        }
        this.disposeSubviews();
        if (this.model) {
          this.model.dispose();
        }
        for (var stat in this.statisticsMini) {
          if (Object.prototype.hasOwnProperty.call(this.statisticsMini, stat)) {
            this.statisticsMini[stat] = null;
          }
        }
      }
    }
  );
})(Backbone, _, svs);

 })(window);